export default "<app-table-page></app-table-page>"